import { useState } from 'react'

import {
  useApproveArticleApprovalApi,
  useArticleApprovalsListApi
} from '@/common/api/modules/articleApproval'
import { useFirstLoading } from '@/common/api/search'
import { useSiteId } from '@/common/app/site'

import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import PageListSearching from '@/components/view/molecules/loading/PageListSearching'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AppTitleBadge, { AppTitleBadgeType } from '@/components/container/layout/AppTitleBadge'
import ArticleApprovalSearchConditionField, {
  ArticleApprovalCondition,
  DEFAULT_ARTICLE_APPROVAL_CONDITION
} from '@/components/container/modules/media/article/ArticleApprovalSearchConditionField'
import ArticleApprovalTable from '@/components/container/modules/media/article/ArticleApprovalTable'

const ArticleApprovalListPage = () => {
  const siteId = useSiteId()
  const [condition, setCondition] = useState<ArticleApprovalCondition>(
    DEFAULT_ARTICLE_APPROVAL_CONDITION
  )

  const {
    data: requests,
    isLoading: requestsLoading,
    mutate: mutateRequests
  } = useArticleApprovalsListApi({
    site_id: siteId,
    status: condition.status,
    requested_by: condition.requestedBy,
    approver_id: condition.approverId
  })

  const [approvingId, setApprovingId] = useState<number | null>(null)
  const { trigger: approveRequest } = useApproveArticleApprovalApi({
    onSuccess: () => {
      setApprovingId(null)
      mutateRequests()
    },
    onError: () => setApprovingId(null)
  })
  const handleApprove = (requestId: number) => {
    setApprovingId(requestId)
    approveRequest({ site_id: siteId, request_id: requestId })
  }

  const isFirstLoadingRequests = useFirstLoading(requestsLoading)

  return (
    <Main type={MainLayoutType.FULL}>
      <PageTitle
        title='承認リクエスト一覧'
        description='記事バージョンに対する承認リクエストを一覧管理します。'
        badgeNode={<AppTitleBadge type={AppTitleBadgeType.MEDIA} />}
      />

      <Content>
        {isFirstLoadingRequests ? (
          <PageListLoading />
        ) : (
          <Area>
            <ArticleApprovalSearchConditionField
              condition={condition}
              setCondition={setCondition}
            />
            {requestsLoading ? (
              <PageListSearching />
            ) : requests?.length ? (
              <ArticleApprovalTable
                siteId={siteId}
                requests={requests}
                onApprove={handleApprove}
                approvingId={approvingId}
                onScheduleChanged={mutateRequests}
              />
            ) : (
              <NoResultGuidance searched name='承認リクエスト' />
            )}
          </Area>
        )}
      </Content>
    </Main>
  )
}

export default ArticleApprovalListPage
